import { Link } from "react-router-dom";

const FooterHeading = ({ children }) => <p className="eyebrow mb-4">{children}</p>;
const footerLink = "block text-sm text-zinc-600 hover:text-zinc-900 transition-colors py-1";

const PublicFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-zinc-200 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-16 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-6">
            <Link to="/" className="font-logo text-xl text-[#303030]">Club Pass</Link>
            <p className="text-sm text-zinc-500 mt-3 max-w-xs leading-relaxed">
              Digital membership cards for airsoft clubs, issued straight to Google Wallet.
            </p>
          </div>
          <div className="md:col-span-2">
            <FooterHeading>Product</FooterHeading>
            <Link to="/pricing" className={footerLink}>Pricing</Link>
            <Link to="/login" className={footerLink}>Sign in</Link>
          </div>
          <div className="md:col-span-2">
            <FooterHeading>Legal</FooterHeading>
            <Link to="/privacy" className={footerLink}>Privacy</Link>
            <Link to="/terms" className={footerLink}>Terms</Link>
          </div>
          <div className="md:col-span-2">
            <FooterHeading>Company</FooterHeading>
            <a href="https://airsoftsystems.co.nz" className={footerLink}>Airsoft Systems</a>
            <a href="mailto:info@airsoftsystems.co.nz" className={footerLink}>Contact</a>
          </div>
        </div>
        <p className="text-xs text-zinc-400 mt-14 pt-6 border-t border-zinc-100">
          &copy; {year} Airsoft Systems. Club Pass is a product of Airsoft Ventures Limited.
        </p>
      </div>
    </footer>
  );
};

export default PublicFooter;
